export default __webpack_public_path__ + "static/char-s-42-ko-c4fb290e2c8c96b8d7bcb6d3421a4ca5.png";